<template>
  <v-container data-aos="fade">
    <h1 class="text-center">{{title}}</h1>

    <p>
        Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before
        using any event catering and retreat/private chef or classes/workshops/courses services (the
        "Service") offered by Chef Naturelle ("us", "we", or "our", "Chef Naturelle", "Stéphanie").
    </p>
    <p>
        Your access to and use of the Service is conditioned on your acceptance of and compliance
        with these Terms. These Terms apply to all users and others who access or use the Service.
        By accessing or using the Service you agree to be bound by these Terms. If you disagree
        with any part of the terms then you may not access the Service.
    </p>

    <h4>1. Bookings</h4>

    <p>
        All event bookings must be confirmed in writing by the Client and a deposit is required to
        secure your booking. By confirming your booking and paying the deposit you are deemed to
        have read, accepted and understood these terms and conditions.
    </p>

    <v-container class="indent">
      <h5>Classes, Workshops &amp; Courses</h5>

      <p>
        All classes, workshops and courses are transferable but non-refundable.
      </p>
      <p>
        If you are unable to attend an open session you have booked, you can transfer your ticket
        to another person (please let us know the details of the new person at least 3 days
        before). Otherwise, we will relist your place for resale to other customers. If we are
        unable to resell your place in the time remaining, you will forfeit any payment you have
        made. If you are unable to attend a private session you have booked, you can transfer
        your booking to a future date.
      </p>
      <p>
        For all classes, workshops and courses you can no longer attend, please email Stéphanie
        <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a> as soon as
        possible. Please provide at least 7 days notice for open sessions and at least 30 days
        notice for private sessions. If you cancel later than this, transfer and availability
        of another spot is at our discretion and cannot be guaranteed.
      </p>
      <p>
        We cannot be held liable for weather, travel, illness or any other situations that occur
        out of our control.
      </p>
      <p>
        In cases where a deposit has been paid, the final payment will be due at least 30 days
        before the course date. The deposits are non-refundable and will be non-transferable
        after the 1 month mark. If payment has not been made on the due date we hold the right
        to release your reservation. If you are unable to attend for whatever reason and you
        have missed the cancellation deadline, you are free to gift or resell your booking but
        we hold no obligation to refund or transfer your booking.
      </p>
      <p>
        In the unlikely event the minimum places do not get filled for the open session we will,
        at your convenience, transfer you onto another course; if this option does not suit, you
        will receive a full refund. This does not apply to vouchers. If we need to cancel for
        any other reason, you will be given the option of a transfer to another course of the
        same value or a full refund.
      </p>
      <p>
        If you purchase a voucher, please note that you are responsible for making the recipient
        aware of these terms &amp; conditions.
      </p>
      <p>
        Prices for private classes are quoted on a given number and if the numbers decrease,
        prices are subject to increase. Refunds are not given or transferred when payment has
        been taken.
      </p>
      <!-- <p>
        All classes, workshops and courses are transferable but non-refundable.
      </p>
      <p>
        If you are unable to attend an open session you have booked, you can either offer your
        booking to another person yourself or you can transfer your booking to a different day. If
        you are unable to attend a private session you have booked, you can transfer your booking
        to a future date.
      </p>
      <p>
        For all classes, workshops and courses you can no longer attend, please email Stéphanie
        <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a> as soon as possible.
        Please provide at least 7 days notice for open sessions and at least 30 days notice for private
        sessions. If you cancel later than this, transfer and availability of another spot is at our
        discretion and cannot be guaranteed.
      </p>
      <p>
        If within the notice period, the amount originally paid can be transferred to another
        class of the same amount and is valid for 6 months from the payment date. We cannot be held
        liable for weather, travel, illness or any other situations that occur out of our control.
      </p>
      <p>
        In cases where a deposit has been paid, the final payment will be due at least 30 days
        before the course date. The deposits are non-refundable and will be non-transferable
        after the 1 month mark. If payment has not been made on the due date we hold the right to
        release your reservation. If you are unable to attend for whatever reason and you have
        missed the cancellation deadline, you are free to gift or resell your booking but we hold
        no obligation to refund or transfer your booking.
      </p>
      <p>
        In the unlikely event the minimum places do not get filled for the open session we will,
        at your convenience, transfer you onto another course; if this option does not suit, you
        will receive a full refund. This does not apply to vouchers.
      </p>
      <p>
        If you purchase a voucher, please note that you are responsible for making the recipient
        aware of these terms &amp; conditions.
      </p>
      <p>
        Prices for private classes are quoted on a given number and if the numbers decrease,
        prices are subject to increase. Refunds are not given or transferred when payment has
        been taken.
      </p> -->

      <h5>Events Catering &amp; Retreat/Private Chef</h5>
      <p>
        A deposit of 50% of the estimated total costs will be required upon booking or at least 12
        weeks prior to your retreat and may be partially or fully retained if it is cancelled. The
        deposit will be deducted from the total event costs which will be issued to the Client no
        later than 5 working days after the event once staff costs and breakages are accounted for.
        Payment of the balance must be made in full no more than 7 days after the final invoice is
        received. An additional deposit may be required for any equipment / hire organised by us
        from third parties. Payment can be made by bank transfer.
      </p>

    </v-container>

    <h4>2. Cancellation Charges</h4>

    <p>
      The Client understands that upon payment of deposit to secure the booking, time and
      resources will be committed by us to deliver the event prior to the date itself.
      Cancellation would also result in lost income and lost business opportunities that are difficult
      to precisely quantify. Therefore the cancellation limitations set out in this policy will apply.
    </p>

    <v-container class="indent">
        <h5>Classes, Workshops &amp; Courses</h5>
        <p>
          All classes, workshops and courses are transferable but non-refundable. Please refer to 1. Bookings above.
        </p>
        <h5>Events/Retreat Catering &amp; Private Chef</h5>
        <p>
          In the unfortunate event that the Client has to cancel a retreat or an event, confirmation in writing
          will be required from the Client via email to
          <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>. The following charges will
          be incurred:
        </p>
        <p>
          <ul>
            <li>Cancellation notice received more than 10 weeks before the event – 0% of the total event cost - full refund</li>
            <li>Cancellation notice received between more than 6 weeks before the event and up to 10 weeks before the event – 25% of the total event cost</li>
            <li>Cancellation notice received between 2 weeks before the event and up to 6 weeks before the event – 50% of the total event cost</li>
            <li>Cancellation notice received less than 2 weeks before the event – 100% of the total event cost</li>
          </ul>
        </p>
        <p>
          In all cases, the total event cost will be based on the total quoted price including
          staff and hire estimates. Should guest numbers be unconfirmed at the time of
          cancellation the total event cost will be based on the originally quoted or most recently
          estimated guest numbers. Any additional costs incurred by us in preparation of the event
          up until the time of cancellation will be charged to the Client if not covered by the
          deposit. This is to cover any losses caused to us for administration costs, travel,
          supplies etc. and will be discussed and itemised fully in the event of cancellation. As
          cancellation insurance is not available to a catering supplier, the Client is advised to
          arrange such insurance to recover their losses.
        </p>
        <p>
          The above applies in all circumstances where you elect to cancel for any reason. The only
          exception being government imposed COVID restrictions for which exceptional measures are
          set out below. If we cancel for any reason, you will be given a full refund of any monies paid.
        </p>
        <p>
          If you want to reschedule your event, you will incur no charges to move the date if we
          are able to accommodate the new date. If we cannot move to an agreeable date, the relevant
          cancellation clause will apply.
        </p>

        <h5>Cancellation Charges: COVID 19 ONLY</h5>
        <p>
          If your event or retreat can no longer go ahead due to national government imposed COVID-19
          restrictions (i.e. it is a legal requirement to cancel), and your deposit has been paid, we
          want to ensure the most flexible solutions for all parties. You will first be offered to transfer
          your deposit to a booking at a later date, but this must be within 12 months of the initial booking
          and can only be moved once (and will not, then, be refundable). If this is not suitable, your
          deposit will be returned to you less any unrecoverable expenses (e.g. equipment hire deposits,
          ingredients that cannot returned/reused/refunded, staff time spent planning your
          event/visiting venues etc).
        </p>
        <p>
          We will endeavour to recover all outlaid costs or transfer them to another event or booking
          before deducting them from your deposit so that we can return your deposit to the fullest
          extent possible.
        </p>

        <h5>Dietary Requirements and Allergies</h5>
        <p>
          Please inform us of any known allergies or dietary requirements at the time of booking. We will
          do our best to provide a suitable menu for any guests with special dietary requirements or mild
          allergies and intolerances. We cannot however accept responsibility for any guests unless advised
          more than one month prior to the event or booking. Please note that we cannot guarantee a 100%
          allergen free environment as we use some allergens in our kitchen. Please consider this and let
          your guests know so that you and they can make an informed decision about the event and any dietary
          needs. Please get in touch to discuss if you have further questions.
        </p>
        <h5>Clients Food and Drinks</h5>
        <p>
          We accept no liability for any food supplied to the Client by another caterer (or food products
          suppliers by the Client themselves) in addition to those arranged by us.
        </p>

        <h5>Client’s use of Our Property and Clients Personal Property or Gifts</h5>
        <p>
          The Client agrees to pay for any loss or damage to any equipment, crockery, cutlery or glassware
          supplied by Us for the event, including any issues caused by the Client guests.
        </p>
        <h5>Liability</h5>
        <p>
          We accept no liability under any claim whatsoever (be it by negligence or otherwise) arising from
          any loss over the figure of our existing Public Liability Limit of Indemnity.  Note that this figure,
          which may change from time to time, is available upon request.
        </p>
        <h5>Force Majeure</h5>
        <p>
          We shall incur no liability to the Client if performance of the contract is prevented by any case
          whatsoever beyond our control and in particular but without prejudice to the generality of the
          foregoing, by act of fire, flood, subsidence, sabotage, accident, strike, pandemic or lock out and
          shall not be liable for any loss or damage resulting there from suffered by the Client.
        </p>
        <h5>Future Changes to Terms and Conditions</h5>
        <p>
          We reserve the right to change our Terms and Conditions when necessary due to the continual
          evolving nature of our business. It is your responsibility to ensure that you are up to date with
          our Terms and Conditions.
        </p>


    </v-container>
    <v-container>
      <p>Updated Sept 2022</p>
    </v-container>

  </v-container>
</template>

<script>
import {
  VContainer,
} from 'vuetify/lib'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    VContainer,
  },
  data() {
    return {
      title: 'Terms & Conditions'
    }
  },
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}

h5 {
  font-size: 16px;
  // text-decoration: underline;
  padding-bottom: 10px;
}

p, li {
  font-size: 15px;
}

.indent {
  padding-left: 30px;
}
</style>
